import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '../lib/authGuard';
import { parseAccountOpeningFlag } from '@/domains/sales/wizard/accountOpening';

// Módulo /wizard (componente 05-F2) — pantalla completa gateada por sesión. Gateo por rol `seller`
// pendiente (dev: sin validación de roles, igual que el grupo `_backoffice`; ver authGuard). Los
// pasos viven bajo /wizard/s/:sessionId/*.
export const Route = createFileRoute('/wizard')({
    // `?sku=` — deep-link «Iniciar venta» del catálogo del portal. El paso 01 lo liga a la sesión
    // (linkedSku) y el 04 abre con ese equipo elegido.
    // `?phone=` y `?prospect=` — deep-link "Reanudar" de la bandeja de prospectos: el paso 01 arranca
    // con el número escrito y la sesión nueva se vincula al prospecto, que es lo que hace que el silo
    // lo cierre solo al completarse la venta.
    // `?accountOpening=1` — «Abrir cuenta» del menú: la sesión nace como apertura, sin venta.
    validateSearch: (
        search: Record<string, unknown>,
    ): { sku?: string; phone?: string; prospect?: string; accountOpening?: true } => ({
        sku: typeof search.sku === 'string' && search.sku !== '' ? search.sku : undefined,
        phone: typeof search.phone === 'string' && search.phone !== '' ? search.phone : undefined,
        prospect:
            typeof search.prospect === 'string' && search.prospect !== ''
                ? search.prospect
                : undefined,
        accountOpening: parseAccountOpeningFlag(search.accountOpening),
    }),
    beforeLoad: ({ context, location }) => requireSession(context.auth, location.pathname),
    component: () => <Outlet />,
});
